import areaRoutes from './routes'

/* @ngInject */
const areaRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(areaRoutes.index.path, {
      url: areaRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'areaCtrl',
      redirectTo: areaRoutes.home.path,
    })
    .state(areaRoutes.home.path, {
      url: areaRoutes.home.url,
      template: require('./templates/home.html'),
    })
    .state(areaRoutes.new.path, {
      url: areaRoutes.new.url,
      template: require('./templates/new.html'),
    })
    .state(areaRoutes.edit.path, {
      url: areaRoutes.edit.url,
      template: require('./templates/edit.html'),
    })
    .state(areaRoutes.details.path, {
      url: areaRoutes.details.url,
      template: require('./templates/details.html'),
    })
}

export default areaRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/area/area.routes.js